(ns hai.workspaces.routes
  (:require [hai.ui.components :as c]
            [hai.web-app.layout :as layout]
            [hai.web-app.routing :as routing]))

(defn page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Workspaces 🚧"]]
   [:div "Coming soon!"]])

(defn routes []
  [["/workspaces" {:name :workspaces
                   ::routing/window-title "Workspaces"
                   :view page}]])